// The drivers whose removal waits for its Undo (D28, UC-65), kept outside
// the Drivers panel so they outlive it. The owner may remove a driver, open
// another task and come back within the ten seconds: the panel that mounts
// then still leaves him out of every read, and when the Undo runs out or is
// tapped, whichever panel is on screen reads the list again
// (owner/notices.svelte.ts holds the Undo itself).
//
// A removal the server refused is said here too, by the driver's name, so a
// panel opened after it still shows it.

let pending = $state<string[]>([]);
let settled = $state(0);
let refused = $state('');

/** Drivers that leave every read until their removal settles. */
export function pendingRemovals(): readonly string[] {
	return pending;
}

/** Counts each removal that settled, sent or undone; a panel reads again when it moves. */
export function removalsSettled(): number {
	return settled;
}

/** The name of the last driver whose removal the server refused, or ''. */
export function refusedRemoval(): string {
	return refused;
}

export function holdRemoval(driverId: string): void {
	refused = '';
	if (!pending.includes(driverId)) pending = [...pending, driverId];
}

/** The removal was sent or undone: show the server's list again. */
export function settleRemoval(driverId: string, refusedName = ''): void {
	pending = pending.filter((id) => id !== driverId);
	if (refusedName) refused = refusedName;
	settled++;
}

export function clearRefusedRemoval(): void {
	refused = '';
}
